import useEntity from "../../hooks/usePrice";
import PriceDetail from "../../components/price/PriceDetail/PriceDetail";
import PriceScoped from "../../components/price/PriceDetail/PriceScoped";
import PriceTabs from "../../components/price/PriceDetail/PriceTabs";
import { useGetPriceQuery } from "../../apis/Price.api";
import { PrimaryPrice } from "../../types/models/Price";
import React from "react";
import {Delete, Edit} from "@mui/icons-material";
import {Box, Paper, Stack, Button} from "@mui/material";
import {NavLink, useParams, useSearchParams} from "react-router";
import {useStateSession} from "../../../hooks/useAuth";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const PriceDetailPage = () => {

    useTitle(t`Details Price`);

    const session = useStateSession()
    const [searchParams] = useSearchParams();
    const scoped = searchParams.get("scoped");
    const { priceId: id } = useParams();

    const { data, refetch } = useGetPriceQuery(PrimaryPrice.fromPath(id))
    const { deletePrice } = useEntity();

    const onDelete = React.useCallback((e: any) => {
        e.stopPropagation()
        deletePrice(data, '..')
    }, [data, deletePrice])

    if (id === 'scoped') {
        return (<PriceScoped/>)
    }

    return (
        <Box data-testid="Price-details">
            { data && <Paper sx={ { padding: "2em" } }>
                <PriceDetail data={data} refetch={refetch} scoped={scoped}/>
                <Stack direction="row" spacing={1} sx={{ justifyContent: "center", marginTop: "2em"}}>
                    
                    { (session.hasPermission(
            data.scopeGroupId,
            'applications/timber/entities/Prices/update/view'
        ) ||
false) &&
                        <Button size="small" variant="outlined" data-testid="Price-edit-button" startIcon={<Edit />}
                                component={NavLink}
                                to="edit"
                                relative="route"
                                viewTransition={true}
                        >
                            <Trans>Edit</Trans>
                        </Button>
                    }
                    { (session.hasPermission(
            data.scopeGroupId,
            'applications/timber/entities/Prices/delete/view'
        ) ||
false) &&
                        <Button size="small" color="error" variant="outlined" data-testid="Price-delete-button" startIcon={<Delete />}  onClick={(e) => onDelete(e)}>
                            <Trans>Delete</Trans>
                        </Button>
                    }
                </Stack>
            </Paper>}

            { data && <Stack direction="row" spacing={1} sx={ { marginTop: "2em" } }>
                <PriceTabs data={data} />
            </Stack>}
        </Box>
    )
}

export default PriceDetailPage;
